(()=>{
 'use strict';
 if(customElements.get('arya-product-tabs'))return;
 class AryaProductTabs extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();
   const signal=this.controller.signal;
   this.tabs=[...this.querySelectorAll('[data-av-tab]')];
   this.panels=[...this.querySelectorAll('[data-av-panel]')];
   if(this.tabs.length!==this.panels.length||!this.tabs.length)return;
   const specs=this.querySelector('[data-av-specs-panel]'),description=this.querySelector('.product__description'),empty=specs?.querySelector('[data-av-specs-empty]');
   if(specs){
    const verified=!!specs.querySelector('[data-product-facts]');
    if(!verified&&description){
     for(const heading of [...description.children]){
      const label=heading.textContent.trim().replace(/:$/,'').toLowerCase(),list=heading.nextElementSibling;
      if(!['المواصفات','specifications','technical specifications','specification'].includes(label)||!list||!['UL','DL','TABLE'].includes(list.tagName))continue;
      const content=document.createElement('div');content.className='av-existing-specs rte';content.append(list);specs.prepend(content);heading.remove();break;
     }
    }
    if(!verified&&!specs.querySelector('.av-existing-specs')&&description&&document.documentElement.lang.startsWith('en')){
     const list=[...description.children].find(e=>e.tagName==='UL');if(list){const content=document.createElement('div');content.className='av-existing-specs rte';content.append(list);specs.prepend(content);}
    }
    const hasSpecs=verified||!!specs.querySelector('.av-existing-specs,.av-technical-specs,.av-extra-details,[data-av-product-media]');if(empty)empty.hidden=hasSpecs;
    if(!hasSpecs){const tab=this.querySelector('[data-av-specs-tab]');if(tab){tab.hidden=true;this.tabs=this.tabs.filter(t=>t!==tab);this.panels=this.panels.filter(p=>p!==specs);}specs.hidden=true;}
   }
   this.querySelector('[data-av-tablist]')?.setAttribute('role','tablist');
   this.tabs.forEach((tab,i)=>{
    tab.id=tab.id||`av-tab-${this.dataset.section}-${i}`;
    tab.setAttribute('role','tab');tab.setAttribute('aria-controls',this.panels[i].id);
    this.panels[i].setAttribute('role','tabpanel');this.panels[i].setAttribute('aria-labelledby',tab.id);this.panels[i].tabIndex=0;
    tab.addEventListener('click',event=>{event.preventDefault();this.activate(i,false);},{signal});
    tab.addEventListener('keydown',event=>{
     const rtl=document.documentElement.dir==='rtl';let next;
     if(event.key==='Home')next=0;else if(event.key==='End')next=this.tabs.length-1;
     else if(event.key==='ArrowRight')next=(i+(rtl?-1:1)+this.tabs.length)%this.tabs.length;
     else if(event.key==='ArrowLeft')next=(i+(rtl?1:-1)+this.tabs.length)%this.tabs.length;
     if(next===undefined)return;event.preventDefault();this.activate(next,true);
    },{signal});
   });
   this.activate(0,false);this.classList.add('is-ready');
   if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
    if(String(event?.data?.sectionId)!==this.dataset.section||!event.data.html)return;
    const host=this.closest('product-info');if(!host)return;
    for(const key of ['AryaHighlights','AryaPreflight','AryaMedia']){
     const id=`${key}-${this.dataset.section}`,source=event.data.html.getElementById(id),target=host.querySelector(`[id="${id}"]`);
     if(!source||!target)continue;target.innerHTML=source.innerHTML;target.hidden=source.hidden;
     if(source.dataset.variantId)target.dataset.variantId=source.dataset.variantId;
    }
   });
  }
  activate(index,focus){this.tabs.forEach((tab,i)=>{const selected=i===index;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;this.panels[i].hidden=!selected;});if(focus)this.tabs[index].focus();}
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.unsubscribe?.();this.unsubscribe=null;}
 }
 customElements.define('arya-product-tabs',AryaProductTabs);
})();

// Localize the app's text nodes without replacing its native tier controls or prices.
(()=>{
 const host=document.querySelector('product-info');if(!host)return;
 const ar=document.documentElement.lang.startsWith('ar');
 const localize=()=>host.querySelectorAll('.lb-qty-selector-discounted-price-text,.lb-qty-selector-saved-price-text').forEach(el=>{
  for(const node of el.childNodes){if(node.nodeType!==Node.TEXT_NODE)continue;const old=node.nodeValue;
   const next=ar?old.replace(/\beach\b/g,'للقطعة تقريبًا').replace(/You save/g,'توفّر'):old.replace(/\beach\b(?! \(approx\.\))/g,'each (approx.)');
   if(next!==old)node.nodeValue=next;
  }
 });
 let pending=false;const queue=()=>{if(pending)return;pending=true;queueMicrotask(()=>{pending=false;localize();});};
 new MutationObserver(queue).observe(host,{childList:true,subtree:true});localize();
})();
